import { render, staticRenderFns } from "./Defective.vue?vue&type=template&id=76c0022a&scoped=true&"
import script from "./Defective.vue?vue&type=script&lang=js&"
export * from "./Defective.vue?vue&type=script&lang=js&"
import style0 from "./Defective.vue?vue&type=style&index=0&id=76c0022a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0022a",
  null
  
)

export default component.exports